import React from "react";
import { Document, Page, Text, View, Image } from "@react-pdf/renderer";
import { RelatorioStyles as styles } from "./styles";

type Dados = {
  ANTERIOR: number;
  INCLUSAO: number;
  REATIVACAO: number;
  EXCLUSAO: number;
  TOTAL: number;
};

interface RelatorioPDFProps {
  data: {
    TITULAR: Dados;
    DEPENDENTE: Dados;
  };
  lotacao?: string;
  dateRange: {
    inicio: string;
    fim: string;
  };
}

const RelatorioPDF: React.FC<RelatorioPDFProps> = ({
  data,
  lotacao,
  dateRange,
}) => {
  const totalGeral = {
    ANTERIOR: 0,
    INCLUSAO: 0,
    REATIVACAO: 0,
    EXCLUSAO: 0,
    TOTAL: 0,
  };

  Object.values(data).forEach((d) => {
    totalGeral.ANTERIOR += d.ANTERIOR;
    totalGeral.INCLUSAO += d.INCLUSAO;
    totalGeral.REATIVACAO += d.REATIVACAO;
    totalGeral.EXCLUSAO += d.EXCLUSAO;
    totalGeral.TOTAL += d.TOTAL;
  });

  return (
    <Document>
      <Page style={styles.page} orientation="landscape">
        {/* Cabeçalho */}
        <View style={styles.header}>
          <View style={styles.logoContainer}>
            <Image
              src={require("../../../assets/logo-imagem.png")}
              style={styles.logo}
            />
          </View>
          <View style={styles.headerText}>
            <Text style={styles.institution}>
              Associação Beneficente Nossa Senhora da Conceição
            </Text>
            <Text style={styles.details}>
              Santa Casa de Misericórdia e Maternidade Nossa Senhora da
              Conceição
            </Text>
            <Text style={styles.details}>
              CNPJ 47.531.835/0001-31 Inscrição Estadual: isenta
            </Text>
            <Text style={styles.details}>
              Avenida Padre Rodolfo, 320 - Alto do Cruzeiro - 12530-000 -
              Cunha-SP
            </Text>
            <Text style={styles.title}>
              RELATÓRIO DE MOVIMENTAÇÕES DOS CONTRIBUINTES
            </Text>
          </View>
        </View>

        {/* Tabela */}
        <View style={styles.table}>
          <View style={styles.row}>
            <Text style={styles.cellHeader}>Categoria</Text>
            <Text style={styles.cellHeader}>Anterior</Text>
            <Text style={styles.cellHeader}>Inclusão</Text>
            <Text style={styles.cellHeader}>Reativação</Text>
            <Text style={styles.cellHeader}>Exclusão</Text>
            <Text style={styles.cellHeader}>Total</Text>
          </View>

          {Object.entries(data).map(([key, value]) => (
            <View style={styles.row} key={key}>
              <Text style={styles.cell}>{key}</Text>
              <Text style={styles.cell}>{value.ANTERIOR}</Text>
              <Text style={styles.cell}>{value.INCLUSAO}</Text>
              <Text style={styles.cell}>{value.REATIVACAO}</Text>
              <Text style={styles.cell}>{value.EXCLUSAO}</Text>
              <Text style={styles.cell}>{value.TOTAL}</Text>
            </View>
          ))}

          <View style={styles.row}>
            <Text style={styles.cell}>TOTAL GERAL</Text>
            <Text style={styles.cell}>{totalGeral.ANTERIOR}</Text>
            <Text style={styles.cell}>{totalGeral.INCLUSAO}</Text>
            <Text style={styles.cell}>{totalGeral.REATIVACAO}</Text>
            <Text style={styles.cell}>{totalGeral.EXCLUSAO}</Text>
            <Text style={styles.cell}>{totalGeral.TOTAL}</Text>
          </View>
        </View>

        {/* Filtros aplicados */}
        <View style={styles.filtersMainContainer}>
          <View style={styles.filters}>
            <View style={styles.filterContainer}>
              <Text style={styles.filterText}>Lotação: </Text>
              <Text style={styles.filterTextBold}>{lotacao || "Todas"}</Text>
            </View>
            <View style={styles.filterContainer}>
              <Text style={styles.filterText}>Período: </Text>
              <Text style={styles.filterTextBold}>
                {dateRange.inicio} até {dateRange.fim}
              </Text>
            </View>
          </View>
        </View>

        {/* Rodapé */}
        <View style={styles.footer}>
          <Text>Data de emissão: {new Date().toLocaleDateString("pt-BR")}</Text>
          <Text
            render={({ pageNumber, totalPages }) =>
              `Página: ${pageNumber} de ${totalPages}`
            }
          />
          <Text>Desenvolvido por FATECOINS</Text>
        </View>
      </Page>
    </Document>
  );
};

export default RelatorioPDF;
